<template>
  <div id="app">
    <div class="header">
      <div class="headerTxt">
        <img src="./assets/homeImg/logo.png" class="headerLogin">
        <div class="headerRight">
          <nav class="nav">
            <router-link to="/">首页</router-link>
            <router-link to="/measuring">测徒者V8</router-link>
            <router-link to="/secondhand">二手仪器</router-link>
            <router-link to="/subscribe">预约试机</router-link>
            <router-link to="/login" v-show="loginTxtShow">登录</router-link>
            <el-dropdown trigger="click"  v-show="myMsgShow" style="margin-right: 70px">
              <span class="el-dropdown-link">
                {{userName}}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" style="background: black;border: none;" class="header-new-drop">
                <el-dropdown-item><router-link to="/myOrder"  style="color: white">我的订单</router-link></el-dropdown-item>
                <el-dropdown-item ><a  @click="cancellation">注销</a></el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </nav>
          <div class="phone">
            <img src="./assets/homeImg/phoneiocn.png">
            <span>服务热线：18615752260</span>
          </div>
        </div>
      </div>
    </div>
    <router-view class="content"/>
    <div class="footer" v-show="$route.meta.isShow">
      <div class="support">
        <div>
          <img src="./assets/homeImg/sevendaysicon.png" class="supportImg">
          <span class="supportTxt">7天无理由退货</span>
          <div class="line"></div>
        </div>
        <div>
          <img src="./assets/homeImg/trienniumicon.png" class="supportImg">
          <span class="supportTxt">支持整机器质保3年</span>
          <div class="line"></div>
        </div>
        <div>
          <img src="./assets/homeImg/lifeLongicon.png" class="supportImg">
          <span class="supportTxt">支持终身升级换货</span>
          <div class="line"></div>
        </div>
        <div>
          <img src="./assets/homeImg/sficon(1).png" class="supportImg">
          <span class="supportTxt">顺丰包邮</span>
        </div>
      </div>
      <div class="aboutUs">
        <img src="./assets/homeImg/footerlogo.png" class="aboutUsImg">
        <div class="aboutUsTxt">
          <div>以旧换新</div>
          <div>二手仪器</div>
          <div>预约试机</div>
          <div>客服电话</div>
          <div class="phone">18615752260</div>
        </div>
        <div class="qrCode">
          <div>
            <img src="./assets/homeImg/cd.jpg">
            <div class="qrCodeTxt">客服微信</div>
          </div>
          <div>
            <img src="./assets/homeImg/cd.jpg">
            <div class="qrCodeTxt">微信公众号</div>
          </div>
        </div>
      </div>
      <div class="footerTxt"><a class="text-color" href="https://beian.miit.gov.cn" target="_blank">蜀ICP备2022012610号-1</a></div>
    </div>
    <div class="rollNav" v-show="show">
      <div class="rollNavContent">
        <div class="rollNavContentLeft">
          <img src="./assets/homeImg/logo.png" class="headerLogin">
          <div class="line"></div>
          <div class="rollNavContentLeftTxt">全国统一零售价<span>1.10</span>万元</div>
        </div>
        <div class="rollNavContentRight">
          <div class="rollNavContentRightTxt">
            <div @click="goSubscribe">预约试机</div>
            <div @click="nowBuy">立即定购</div>
          </div>
          <div class="phone">
            <img src="./assets/homeImg/phoneiocn.png">
            <span style="font-size: 14px">服务热线：18615752260</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      show: false,
      loginTxtShow:false,
      myMsgShow:false,
      userName:''
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scrollToTop);
  },
  methods: {
    scrollToTop() {
      if (document.documentElement.scrollTop > 60) {
        this.show = true
      }
      if (document.documentElement.scrollTop <= 60) {
        this.show = false
      }
    },
    nowBuy(){
      this.$router.push({
        name:'addGoods',
      })
    },
    goSubscribe(){
      this.$router.push({name:'subscribe'})
    },
    // 获取用户信息
     haveToken(){
      if(localStorage.getItem('Authorization')){
        this.myMsgShow=true
        this.$store.dispatch('home/selectByUser').then(()=>{
          this.userName=this.$store.state.home.userName
        }).catch(()=>{
        })
      }else {
        this.loginTxtShow=true
      }
    },
    // 注销
    cancellation(){
     this.$store.dispatch('home/loginOut')
      this.$router.push({name:'login'})
    }
  },
  computed: {},
  created() {
    this.haveToken()
  },

};
</script>
<style lang="less" >
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  display: flex;
  flex-direction: column;
  cursor: default;

}

nav a.router-link-exact-active {
  color: #FFFFFF;
  opacity: 0.7;
}

.header {
  height: 60px;
  background: rgba(0, 0, 0, 0.9);
}

.headerTxt {
  height: 60px;
  display: flex;
  width: 1500px;
  margin: auto;
  justify-content: space-between;
  color: #FFFFFF;
  align-items: center;

  a {
    color: white;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    margin-right: 70px;
  }

  .headerLogin {
    width: 108px;
  }

  .headerRight {
    display: flex;

    .phone {
      display: flex;
      align-items: center;

      img {
        margin-right: 5px;
      }
      span{
        font-size: 14px;
      }
    }
  }
}

.footer {
  background: #2B2B2B;
  padding: 23px 0px 18px 0px;
  position: relative;

  .support {
    display: flex;
    width: 1403px;
    margin: auto;
    justify-content: space-around;

    > div {
      display: flex;
      align-items: center;

      .supportImg {
        width: 50px;
        margin-right: 7px;
      }

      .supportTxt {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #CCCCCC;
        margin-right: 41px;
      }

      .line {
        width: 1px;
        height: 24px;
        background: #999999;
        margin-left: 76px;
        margin-right: 90px;
      }
    }

    > div:last-child {
      margin-right: 0px;
    }
  }

  .aboutUs {
    width: 1500px;
    margin: 44px auto 197px;
    display: flex;
    align-items: center;
    position: relative;
    .aboutUsImg {
      margin-right: 104px;
    }

    .aboutUsTxt {
      display: flex;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      position: relative;
      > div {
        margin-right: 121px;
      }
      .phone {
        position: absolute;
        top: 46px;
        right: -80px;
        font-size: 21px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #F87B00;
      }
    }
    .qrCode {
      display: flex;
      position: absolute;
      top: 37px;
      right: 0px;

      > div {
        text-align: center;
        img {
          width: 100px;
          height: 100px;
        }

        .qrCodeTxt {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
          margin-top: 8px;
        }
      }
      >div:nth-child(2){
        margin-left: 76px;
      }
    }
  }

  .footerTxt {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #D2D2D2;
    text-align: center;
  }



}

.rollNav {
  width: 100%;
  height: 60px;
  background: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0px;
  z-index: 999;

  .rollNavContent {
    height: 60px;
    display: flex;
    width: 1500px;
    margin: auto;
    justify-content: space-between;
    color: #FFFFFF;
    align-items: center;

    .headerLogin {
      width: 108px;
    }

    .rollNavContentLeft {
      display: flex;
      align-items: center;

      .line {
        width: 1px;
        height: 16px;
        background: #FFFFFF;
        opacity: 0.6;
        margin-right: 10px;
      }

      .rollNavContentLeftTxt {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: 300;
        color: rgba(255, 255, 255, 0.6);

        span {
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #FFFFFF;
        }
      }

    }

    .rollNavContentRight {
      display: flex;

      .phone {
        display: flex;
        align-items: center;

        img {
          margin-right: 5px;
        }
      }

      .rollNavContentRightTxt {
        display: flex;

        div {
          width: 166px;
          height: 36px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          border-radius: 18px;
          font-weight: 400;
          line-height: 36px;
          color: #FFFFFF;
          margin-right: 24px;
          text-align: center;
          cursor: pointer;
        }

        > div:first-child {
          border: 1px solid rgba(255, 255, 255, 0.5);
        }

        > div:last-child {
          background: #F87B00;
          border: 1px solid #F87B00
        }
      }
    }
  }

}

.el-dropdown-link {
  cursor: pointer;
  color: white;
}
.header-new-drop li:hover {
  background: black !important;
}
.header-new-drop .popper__arrow::after{
  border-bottom-color: #000!important;
  top: 0px!important;
}
.header-new-drop   .popper__arrow{
  border-bottom-color:black !important;
  left: 43px !important;
}
.content{
  flex: 1;
}

</style>
